module.exports = __webpack_public_path__ + "static/media/recife-pe.7dc298d0.jpg";